import { render, staticRenderFns } from "./SubAccountSettings.vue?vue&type=template&id=d58affaa"
import script from "./SubAccountSettings.vue?vue&type=script&lang=js"
export * from "./SubAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports